import React from 'react'
import Content from '../components/Content'
import Button from '../components/Button'
import bg from "../images/IMG_0095.jpg"
import tv from "../images/icons8-retro-tv-24.png"
import washing from "../images/icons8-washing-24.png"
import wifi from "../images/icons8-wi-fi-24.png"
import work from "../images/icons8-briefcase-24.png"
import room from "../images/icons8-room-24.png"
import ac from "../images/icons8-ac-24.png"
import {ROOM_OPTIONS} from "../constant"
import Footer from '../components/Footer'
import Nav from '../components/Nav'
import dulex from "../images/dulex.JPG"
import executive from "../images/executive.JPG"
import super_executive from "../images/superexecutive_room.JPG"
import super_dulex from "../images/superdulex_room.JPG"
import honeymoon from "../images/honeymoon_room.JPG"
import president from "../images/president_room.JPG"
export const images=[dulex,super_dulex,executive,super_executive,honeymoon,president]
const Room = () => {
  return (
    <div>
       
        <div className="h-3/4 bg bg-center bg-cover">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-7xl">ROOM</p>
          </div>
          </div>
          </div>
         
            {ROOM_OPTIONS.map((roomOb,i)=>{
         if (i%2===0){
            return(
    <div className="container p-6 flex md:flex-row md:w-4/5 max-h-prose mx-auto place-self-center flex-col">
   <div className="bg-white shadow-lg mt-4 p-3 m-3 md:w-3/4 w-full mx-auto h-3/4 z-10 border-1 place-self-center md:-mr-9">
        <Content  isColor={true} title="ROOM"
        subtitle={roomOb.name}
        content="Warm, comfortable and bright rooms . All delux rooms have large king-size beds, with high
quality hypoallergenic mattresses."/>
<div className="grid grid-cols-1 md:grid-rows-2 md:grid-cols-3 gap-4 p-3 pb-5">
  <div><img className="float-left pr-3" src={wifi} alt="bg"/><p>High-speed internet</p></div>
  <div><img className="float-left pr-3" src={ac} alt="bg"/><p>Air conditioning</p></div>
   <div><img className="float-left pr-3" src={work} alt="bg"/><p>Workspace</p></div>
   <div><img className="float-left pr-3" src={tv} alt="bg"/><p>LED Television</p></div>
   <div><img className="float-left pr-3" src={washing} alt="bg"/><p>Laundry Service</p></div>
   <div><img className="float-left pr-3" src={room} alt="bg"/><p>Room Service</p></div>
   </div>
  
<div className="flex flex-wrap justify-between p-2 text-black border border-transparent border-t-gray-100">
    <p className="place-self-center font-semibold text-lg ">VIEW DETAILS</p>
    <Button isColour={true} href="/inquiry" label='INQUIRY NOW'/></div>
        
      
</div>
      <img className="z-0 md:w-1/2 bg-cover" src={images[i]} alt="img"/> 
    
    </div>
 
)}

else{
  return(
    <div className="container p-6 flex md:flex-row-reverse md:w-4/5 max-h-prose mx-auto place-self-center flex-col">
   <div className="bg-white shadow-lg mt-4 p-6 m-3 md:w-3/4 w-full mx-auto h-3/4 z-10 border-1 place-self-center md:-ml-9">
        <Content  isColor={true} title="ROOM"
        subtitle={roomOb.name}
        content={roomOb.desc}/>
<div className="grid grid-rows-2 grid-cols-3 gap-4 p-3 pb-5">
  <div><img className="float-left pr-3" src={wifi}/><p>High-speed internet</p></div>
  <div><img className="float-left pr-3" src={ac}/><p>Air conditioning</p></div>
   <div><img className="float-left pr-3" src={work}/><p>Workspace</p></div>
   <div><img className="float-left pr-3" src={tv}/><p>LED Television</p></div>
   <div><img className="float-left pr-3" src={washing}/><p>Laundry Service</p></div>
   <div><img className="float-left pr-3" src={room}/><p>Room Service</p></div></div>
  
<div className="flex flex-wrap justify-between p-2 text-black border border-transparent border-t-gray-100 ">
    <p className="place-self-center font-semibold text-lg">VIEW DETAILS</p>
    <Button isColour={true} href="/inquiry" label='INQUIRY NOW'/></div>
        
      
</div>
      <img className="z-0 md:w-1/2 bg-cover" src={images[i]} alt="img"/> 
    
    </div>
  )
}

})}
<Footer/>
</div>
)
}

export default Room